import { Box, Typography, Button } from '@mui/material';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import getStyles from './styles';
const MotionBox = motion(Box);

const AiBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });

  const backgroundY = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const textY = useTransform(scrollYProgress, [0, 1], ['0%', '200%']);
  const styles = getStyles();

  return (
    <Box component="section" id="home" ref={ref} sx={styles.bannerContainer}>
      <motion.div style={{ y: backgroundY, ...styles.parallaxBackground }}>
        <Box sx={styles.gradientOverlay} />
      </motion.div>
      <motion.div
        animate={{
          y: [0, -20, 0],
          rotate: [0, 5, -5, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }}
        style={styles.floatingBrain}
      >
        <Box
          component="img"
          src="/images/ai-brain.jpg"
          alt="AI Brain"
          sx={styles.brainImage}
        />
      </motion.div>
      <MotionBox style={{ y: textY, ...styles.contentContainer }}>
        <Box
          sx={{ maxWidth: '900px', mx: 'auto', textAlign: 'center', py: 12 }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={styles.badge}
          >
            <Typography sx={styles.badgeText}>
              Leading AI Consulting Company
            </Typography>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <Typography variant="h1" sx={styles.mainHeadline}>
              Reimagining Tomorrow with AI.
              {/* <br />
              <Box component="span" sx={styles.gradientText}>
                Real Impact.
              </Box> */}
            </Typography>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Typography sx={styles.subheadline}>
              We empower organizations to move faster, think smarter, and grow
              stronger with AI solutions that redefine what’s possible. Amizhth
              AI Services is where human creativity meets machine intelligence.
            </Typography>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            style={styles.trustIndicators}
          >
            <Box sx={styles.trustItem}>
              <CheckCircleIcon sx={styles.checkIcon} />
              <span style={{ color: '#A1A1AA' }}>
                500+ AI Projects Delivered
              </span>
            </Box>
            <Box sx={styles.trustItem}>
              <CheckCircleIcon sx={styles.checkIcon} />
              <span style={{ color: '#A1A1AA' }}>Fortune 500 Clients</span>
            </Box>
            <Box sx={styles.trustItem}>
              <CheckCircleIcon sx={styles.checkIcon} />
              <span style={{ color: '#A1A1AA' }}>
                LangChain Certified Partners
              </span>
            </Box>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            style={styles.ctaButtons}
          >
            <Button sx={styles.primaryButton} endIcon={<ArrowForwardIcon />}>
              Get Started Today
            </Button>
            <Button sx={styles.secondaryButton}>
              Discover How AI Can Help You
            </Button>
          </motion.div>
        </Box>
      </MotionBox>
    </Box>
  );
};

export default AiBanner;
